import React from 'react';
import styled from 'styled-components';
import logo from '../assets/liferx-logo.png';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--primary-color);
  margin: 0.5rem 0 2rem;
  padding: 0 1.5rem;
  width: 100%;
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
`;

function Logo() {
  return (
    <LogoContainer>
      <LogoImage src={logo} alt="LifeRx MD Logo" />
    </LogoContainer>
  );
}

export default Logo;